import { ModalController, IonContent, IonGrid, IonRow, IonCol, IonButton, IonIcon, IonList } from '@ionic/angular';
import { Component, ChangeDetectionStrategy, inject, OnDestroy, input } from '@angular/core';
import { Events } from '@providers/common/events.service';
import { addIcons } from "ionicons";
import { close } from "ionicons/icons";

@Component({
    selector: 'modal-resume-detail',
    templateUrl: './modal-resume-detail.component.html',
    styleUrls: ['./modal-resume-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        IonContent,
        IonGrid,
        IonRow,
        IonCol,
        IonButton,
        IonIcon,
        IonList,
    ],
})
export class ResumeDetailChatAIModal implements OnDestroy {
    private modalCtrl = inject(ModalController);
    private events = inject(Events);

    readonly modalTitle = input('');
    readonly resumeDetail = input('');

    constructor() {
        this.events.publish('menulat:togglevisibility');
        addIcons({ close });
    }

    // Se vuelve a mostrar el menu al destruirse el modal, porque Ionic tambien lo
    // cierra con Escape o el boton atras de Android sin pasar por dismiss()
    ngOnDestroy() {
        this.events.publish('menulat:togglevisibility');
    }

    /**
     * @name dismiss
     * @desc Metodo que te regresa en la navegación
     **/
    dismiss() {
        this.modalCtrl.dismiss();
    }
}
